export const environment = {
  env: 'pro',
  production: true,
  appType: 'maroc',
  platform: 'web',
  defaultLang: 'es',
  emulator: false,
  appUpdateUrl: 'https://grandtour-pro.firebaseapp.com',
  version: '0.0.15',
  liveVersion: '0.0.15',
  firebase: {
    apiKey: 'AIzaSyBEwxAI5ZuQTG0VXwomCBLYIkJ5QsCWBHg',
    authDomain: 'grandtour-pro.firebaseapp.com',
    projectId: 'grandtour-pro',
    storageBucket: 'grandtour-pro.appspot.com',
    messagingSenderId: '783574732594',
    appId: '1:783574732594:web:1040b97f95e52d973f112b',
  },
};
